import { render, staticRenderFns } from "./SummaryShippingRoute.vue?vue&type=template&id=fc0eba20&"
import script from "./SummaryShippingRoute.vue?vue&type=script&lang=js&"
export * from "./SummaryShippingRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports